import axios from 'axios'
import baseUrl from 'store/slices/api/baseUrl'

export const exportMeterReadings = async (params = {}) => {
    const queryString = Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== '')
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&')

    const url = `${baseUrl}/metersReading/export${queryString ? `?${queryString}` : ''}`

    const response = await axios({
        url,
        method: 'GET',
        withCredentials: true,
        responseType: 'blob',
    })

    const contentDisposition = response?.headers?.['content-disposition']
    const utf8Name = contentDisposition?.match(/filename\*=UTF-8''([^;]+)/i)?.[1]
    const plainName = contentDisposition?.match(/filename="?([^";]+)"?/i)?.[1]
    const fileName = (utf8Name ? decodeURIComponent(utf8Name) : plainName) || 'meter-readings.xlsx'

    const fileBlob =
        response?.data instanceof Blob
            ? response.data
            : new Blob([response?.data], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              })

    const downloadUrl = window.URL.createObjectURL(fileBlob)
    const link = document.createElement('a')
    link.href = downloadUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(downloadUrl)

    return {fileName}
}
